import { ReactComponent as CUP_WINNER } from './icons/cup_winner.svg';
import { ReactComponent as HOME } from './icons/round-home.svg';
import { ReactComponent as MORE } from './icons/expand_more.svg';
import { ReactComponent as LESS } from './icons/expand_less.svg';
import { ReactComponent as TIME } from './icons/vectorTime.svg';
import { ReactComponent as EXIT } from './icons/exit.svg';
import { ReactComponent as TIMEACTIVE } from './icons/timeActive.svg';
import { ReactComponent as ALL_FIXTURES } from './icons/medal.svg';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreType, TimePeriod } from '../../store/spirs/types';
import { ColoredIcon } from '../Steps/step-parts-components/SportIconAndTitle';
import { useTranslation } from 'react-i18next';
import {
    HeaderType,
    FixtureElement,
    LeftPanelType,
    Sport,
    Tournament
} from '../../models/api/codegen/code';
import { SELECT_SPORT_MENU } from '../../store/spirs/actions';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { ReactComponent as CLOSED } from './icons/closedSport.svg';
import { ReactComponent as OPEN } from './icons/openSport.svg';
import { Category } from '../../models/api/codegen/code';
import { TournamentItem } from './tournamentsTree/TournamentItem';
import {
    makeSelectCategoryTypesBySport,
    makeSelectFixturesByTournament,
    makeSelectRouteTreeType,
    makeSelectSports,
    makeSelectTournamentsByCategoryType
} from './selectors';

import { getHeader } from '../../spirsApi/api-client';
import { SELECT_TIME_PERIOD } from '../../store/spirs/actions';

interface SportsMenuProps {
    toggleVerticalMenu: () => void;
}

export const VerticalMenu = ({
    toggleVerticalMenu,
    leftPanel
}: SportsMenuProps & { leftPanel: LeftPanelType }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [exit, setExit] = React.useState<boolean>(false);
    const [selectedTimePeriod, setSelectedTimePeriodPeriod] = React.useState<
        TimePeriod
    >(TimePeriod.ALL);
    const [header, setHeader] = React.useState<HeaderType | undefined>(
        undefined
    );
    const playerToken = useSelector(
        (store: StoreType) => store.spirs.playerToken
    );

    const handleHomeClick = () => {
        dispatch(SELECT_SPORT_MENU(-1)); // Сбрасываем выбранный спорт
        toggleVerticalMenu();
    };

    const handleRatingClick = () => {
        dispatch(SELECT_SPORT_MENU(-1)); // Сбрасываем выбранный спорт
        toggleVerticalMenu();
    };

    React.useEffect(() => {
        getHeader().then(data => {
            if (!data) {
                return;
            }
            setHeader(data);
        });
    }, [playerToken]);

    const desktopTabRoutes: string[] = !header
        ? []
        : header.menu.filter(m => m.type === 'route').map(m => m.route);
    const preparedRoutes = desktopTabRoutes.map(item =>
        item !== '/' ? `/sport${item}` : item
    );
    const selectedTab = preparedRoutes.includes(location.pathname)
        ? location.pathname
        : false;

    const timePeriods = [
        TimePeriod.ALL,
        TimePeriod.ONE_HOUR,
        TimePeriod.TWO_HOURS,
        TimePeriod.FOUR_HOURS,
        TimePeriod.SIX_HOURS,
        TimePeriod.TWELVE_HOURS,
        TimePeriod.ONE_DAY,
        TimePeriod.TWO_DAYS
    ];

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const selectOption = (period: TimePeriod) => {
        if (period !== TimePeriod.ALL) {
            setExit(true);
        } else {
            setExit(false);
        }

        setSelectedTimePeriodPeriod(period);
        setIsOpen(false);

        dispatch(SELECT_TIME_PERIOD(period));
    };

    const onExit = () => {
        setExit(false);
        setSelectedTimePeriodPeriod(TimePeriod.ALL);
        setIsOpen(false);
        dispatch(SELECT_TIME_PERIOD(TimePeriod.ALL));
    };

    const isShow = React.useMemo(() => {
        const favorites = location.pathname.startsWith('/sport/favorites');
        const prematch = location.pathname.startsWith('/sport/prematch');
        const rating = location.pathname.startsWith('/sport/rating');
        return favorites || prematch || rating;

    }, [location.pathname]);

    return (
        <>
            {isShow && (
                <div className="relative flex justify-center  bg-[#294052] h-[48px] block text-left">
                    <div
                        className="inline-flex justify-between items-center w-full px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                        onClick={toggleDropdown}
                    >
                        {selectedTimePeriod !== TimePeriod.ALL ? (
                            <EXIT
                                style={{ width: '16px', height: '16px' }}
                                className="mt-[8px] ml-[8px]"
                                onClick={onExit}
                            />
                        ) : (
                            ''
                        )}
                        <div className="flex justify-center align-center mt-[2px] mr-[42px]">
                            {exit ? (
                                <TIMEACTIVE className="w-[20px] h-[20px]" />
                            ) : (
                                <TIME className="w-[20px] h-[20px]" />
                            )}
                            <span
                                className="ml-[16px] text-[14px] text=[#C6C7C9]"
                                style={{
                                    fontFamily: 'Roboto',
                                }}
                            >
                                {t(
                                    `verticalMenuTimePeriod.${selectedTimePeriod}`
                                )}
                            </span>
                        </div>
                        {isOpen ? <LESS /> : <MORE />}
                    </div>

                    {isOpen && (
                        <ul className="absolute right-0 w-56 mt-[1px] pt-[8px] pb-[8px] bg-[#294052] mt-[56px] mr-[10px] shadow-lg ring-1 ring-black ring-opacity-5 rounded-[8px] z-50">
                            {timePeriods.map(period => (
                                <li
                                    key={period}
                                    className="flex h-[32px] items-center gap-[10px] pl-4 p-2 text-white cursor-pointer hover:bg-gray-800"
                                    style={{
                                        fontFamily: 'Roboto',
                                    }}
                                    onClick={() => selectOption(period)}
                                >
                                    <div className="relative flex items-center justify-center">
                                        <div
                                            className="rounded-full border-2 flex items-center justify-center"
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                                borderColor: selectedTimePeriod === period ? '#7BBDF3' : '#D1D5DB',
                                                backgroundColor: selectedTimePeriod === period ? 'transparent' : 'transparent'
                                            }}
                                        >
                                            {selectedTimePeriod === period && (
                                                <div
                                                    className="rounded-full"
                                                    style={{
                                                        width: '8px',
                                                        height: '8px',
                                                        backgroundColor: '#7BBDF3'
                                                    }}
                                                ></div>
                                            )}
                                        </div>

                                        <input
                                            type="radio"
                                            id={period}
                                            name="timePeriodOptions"
                                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                            checked={selectedTimePeriod === period}
                                            onChange={() => selectOption(period)}
                                        />
                                    </div>

                                    <label
                                        htmlFor={period}
                                        className="block w-full text-[17px] cursor-pointer"
                                        style={{
                                            color: selectedTimePeriod === period ? '#7BBDF3' : '#FFFFFF'
                                        }}
                                    >
                                        {t(`verticalMenuTimePeriod.${period}`)}
                                    </label>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
            {leftPanel.showHome && (
                <NavLink
                    to={'/sport/home'}
                    className={({ isActive }) =>
                        clsx(
                            'h-[40px] notebook:h-[40px] desktop:h-[48px] text-white text-[13px] max-tablet:font-bold tablet:text-[14px] notebook:text-[16px] flex items-center gap-[16px] pl-[14px] cursor-pointer',
                            isActive &&
                                'bg-[#272D33] max-tablet:border-b-[2px] tablet:border-r-[2px] border-[#d32f3f]'
                        )
                    }
                    onClick={handleHomeClick}
                >
                    <div className="h-[25px] w-[25px]">
                        <HOME />
                    </div>
                    <span>{t('verticalMenuItems.Home')}</span>
                </NavLink>
            )}
            <NavLink
                to="/sport/prematch"
                className={({ isActive }) =>
                    clsx(
                        'h-[40px] notebook:h-[40px] desktop:h-[48px] text-white text-[13px] max-tablet:font-bold tablet:text-[14px] notebook:text-[16px] flex items-center gap-[16px] pl-[14px] cursor-pointer',
                        isActive &&
                            'bg-[#272D33] max-tablet:border-b-[2px] tablet:border-r-[2px] border-[#d32f3f]'
                    )
                }
                onClick={handleRatingClick}
            >
                <div className="h-[25px] w-[25px]">
                    <ALL_FIXTURES/>
                </div>
                <span>{t('verticalMenuItems.allPrematch')}</span>
            </NavLink>
            {leftPanel.showRating && (
                <NavLink
                    to="/sport/rating"
                    className={({ isActive }) =>
                        clsx(
                            'h-[40px] notebook:h-[40px] desktop:h-[48px] text-white text-[13px] max-tablet:font-bold tablet:text-[14px] notebook:text-[16px] flex items-center gap-[16px] pl-[14px] cursor-pointer',
                            isActive &&
                                'bg-[#272D33] max-tablet:border-b-[2px] tablet:border-r-[2px] border-[#d32f3f]'
                        )
                    }
                    onClick={handleRatingClick}
                >
                    <div className="h-[25px] w-[25px]">
                        <CUP_WINNER />
                    </div>
                    <span>{t('verticalMenuItems.Rating')}</span>
                </NavLink>
            )}

            <SportTreeMenu toggleVerticalMenu={toggleVerticalMenu} />
        </>
    );
};

export const SportTreeMenu = ({}: SportsMenuProps) => {
    const selectSports = React.useMemo(makeSelectSports, []);
    const selectCategoryTypesBySport = React.useMemo(
        makeSelectCategoryTypesBySport,
        []
    );
    const selectTournamentsByCategoryType = React.useMemo(
        makeSelectTournamentsByCategoryType,
        []
    );
    const selectFixturesByTournament = React.useMemo(
        makeSelectFixturesByTournament,
        []
    );

    const sports = useSelector((state: StoreType) => selectSports(state));
    const categoryTypes = useSelector((state: StoreType) =>
        selectCategoryTypesBySport(state)
    );
    const tournaments = useSelector((state: StoreType) =>
        selectTournamentsByCategoryType(state)
    );
    const fixtures = useSelector((state: StoreType) =>
        selectFixturesByTournament(state)
    );

    return (
        <>
            {sports.map(sport => (
                <div className="overflow-y-auto" key={sport.si}>
                    <SportMenu
                        sport={sport}
                        categoryTypesMap={categoryTypes}
                        tournamentsMap={tournaments}
                        fixturesMap={fixtures}
                    />
                </div>
            ))}
        </>
    );
};

type SportMenuType = {
    sport: Sport;
    categoryTypesMap: Record<number, Category[]>;
    tournamentsMap: Record<number, Tournament[]>;
    fixturesMap: Record<number, FixtureElement[]>;
};

const SportMenu: React.FC<SportMenuType> = ({
    sport,
    categoryTypesMap,
    tournamentsMap,
    fixturesMap
}) => {
          const dispatch = useDispatch();
          const selectRouteTreeType = React.useMemo(
              makeSelectRouteTreeType,
              []
          );
          const selected = useSelector(
              (state: StoreType) => state.spirs.selectedSportMenu
          );
          const route = useSelector((state: StoreType) =>
              selectRouteTreeType(state)
          );
          const [open, setOpen] = React.useState(false);
          const [openedCategoryType, setOpenedCategoryType] = useState<
              Set<number>
          >(() => new Set());

          const navigate = useNavigate();

          const toggleCategoryType = React.useCallback((id: number) => {
              setOpenedCategoryType(prev => {
                  const next = new Set(prev);
                  next.has(id) ? next.delete(id) : next.add(id);
                  return next;
              });
          }, []);

          const categoryTypes = categoryTypesMap[sport.si];

          const isAnyCategoryTypeOpen = React.useMemo(
              () => openedCategoryType.size > 0,
              [openedCategoryType]
          );

          // Открытие меню вида спорта
          const handleClick = (selected: number) => {
              !open && dispatch(SELECT_SPORT_MENU(selected));
              setOpen(p => !p);
          };

          const handleClickAndNavigate = (selected: number) => {
              !open && dispatch(SELECT_SPORT_MENU(selected));
              setOpen(p => !p);
              navigate(route + selected);
          };

          return (
              <div>
                  <div
                      className={clsx(
                          'h-[40px] notebook:h-[48px] text-white text-[13px] max-tablet:font-bold tablet:text-[14px] notebook:text-[16px] grid items-center justify-between pl-[16px] cursor-pointer',
                          selected === sport.si
                              ? 'max-tablet:border-b-[2px] bg-[#272D33] tablet:border-r-[2px] border-[#d32f3f]'
                              : '',
                          open && !isAnyCategoryTypeOpen && selected === sport.si
                              ? 'border-b-[2px] border-[#FF0000]'
                              : '',
                          selected === sport.si ? "grid-cols-[1fr_25px]" : "grid-cols-[1fr_25px_2px]"
                      )}
                  >
                      <div
                          className="flex items-center gap-5 h-full"
                          onClick={() => handleClickAndNavigate(sport.si)}
                      >
                          <div className="h-[25px] w-[25px]">
                              <ColoredIcon
                                  color={sport.sc}
                                  imageUrl={sport.siu}
                              />
                          </div>
                          <span className={clsx(
                              selected === sport.si && 'font-bold'
                          )}>{sport.sn}</span>
                      </div>
                      <div
                          className="flex items-center h-full w-full"
                          onClick={e => {
                              e.stopPropagation();
                              handleClick(sport.si);
                          }}
                      >
                          <span>{open ? <CLOSED /> : <OPEN />}</span>
                      </div>
                      {selected !== sport.si && (<div/>)}
                  </div>

                  <div>
                      {open &&
                          categoryTypes.map((categoryType: Category, index) => (
                              <CategoryTypeMenu
                                  key={index}
                                  categoryType={categoryType}
                                  tournamentsMap={tournamentsMap}
                                  fixturesMap={fixturesMap}
                                  toggleCategoryType={toggleCategoryType}
                                  route={route}
                              />
                          ))}
                  </div>
              </div>
          );
      };

type CategoryTypeMenuType = {
    categoryType: Category;
    tournamentsMap: Record<number, Tournament[]>;
    fixturesMap: Record<number, FixtureElement[]>;
    toggleCategoryType: (id: number) => void;
    route: string;
};

const CategoryTypeMenu: React.FC<CategoryTypeMenuType> = ({
    categoryType,
    tournamentsMap,
    fixturesMap,
    toggleCategoryType,
    route
}) => {
    const tournaments = tournamentsMap[categoryType.ci];
    const [openCategory, setOpenCategory] = React.useState(false);
    const [openedCategories, setOpenedCategories] = useState<Set<number>>(
        () => new Set()
    );

    const navigate = useNavigate();

    const handleClick = () => {
        setOpenCategory(p => !p);
        toggleCategoryType(categoryType.ci);
    };

    const handleClickAndNavigate = () => {
        setOpenCategory(p => !p);
        toggleCategoryType(categoryType.ci);
        navigate(route + categoryType.si + '/' + categoryType.ci);
    };

    const toggleCategory = React.useCallback((id: number) => {
        setOpenedCategories(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    }, []);

    const isAnyCategoryOpen = React.useMemo(() => openedCategories.size > 0, [
        openedCategories
    ]);

    return (
        <div className="bg-[#1F242A]">
            <div
                className={clsx(
                    'grid grid-cols-[1fr_25px_2px] items-center justify-between cursor-pointer border-b-[2px]',
                    openCategory && !isAnyCategoryOpen
                        ? 'border-[#FF0000]'
                        : 'border-transparent'
                )}
            >
                <div
                    className="flex items-center gap-[16px] h-[40px] desktop:h-[50px]"
                    onClick={handleClickAndNavigate}
                >
                    <img
                        src={categoryType.ciu}
                        alt={'category flag alt'}
                        className="h-[24px] w-[24px] ml-[10px] pl-[14px]"
                    />
                    <li
                        className={clsx(
                            'center mt-[12px] mb-[12px] text-[14px] ml-[10px] list-none',
                            openCategory ? 'text-[#FFFFFF]' : 'text-[#C6C7C9]'
                        )}
                    >
                        {categoryType.cn}
                    </li>
                </div>
                <div
                    className="flex items-center h-full w-full"
                    onClick={e => {
                        e.stopPropagation();
                        handleClick();
                    }}
                >
                    <span>{openCategory ? <CLOSED /> : <OPEN />}</span>
                </div>
                <div />
            </div>
            <div>
                {openCategory &&
                    tournaments.map((tournament: Tournament, index) => (
                        <TournamentItem
                            key={index}
                            tournament={tournament}
                            fixturesMap={fixturesMap}
                            toggleCategory={toggleCategory}
                            sportId={categoryType.si}
                            route={route}
                        />
                    ))}
            </div>
        </div>
    );
};
